export default __webpack_public_path__ + "static/abc-f67527b8d03f7d83ff7d59931d69b19e.png";